import ReactGA from "react-ga";

const useAnalyticsEventTracker = (category) => {
    const eventTracker = (action = "Submit action", label = "Submit Form") => {
        ReactGA.event({category, action, label});
    }
    return eventTracker;
}
export default useAnalyticsEventTracker;
